import PropTypes from "prop-types";
import React from "react";
import monthName from "./monthName";

const Review = (props) => {
  const {
    state,
    type,
    disableButton,
    cancel,
    bookSlot,
    isBookingSlot,
    text,
  } = props;

  return (
    <div className="booked-slot-area">
      <div className="booked-slot">
        <h3>REVIEW</h3>
        <div className="review-main">
          <div className="appointment-area">
            <h3 className="appointment">Appointment</h3>
            <h3 className="device-demo">
              <span>{(type === "nip" ? "NIP" : type) || ""}</span> {text}
            </h3>
          </div>
          <div className="date">
            <h3 className="time">Date & Time</h3>
            {!disableButton ? (
              <h3 className="chosen-slot">
                {state.selectedDay},{" "}
                <span>
                  {monthName(state.month)} {state.date},
                </span>{" "}
                {state.year} at {state.start_time} WAT
              </h3>
            ) : (
              <h3>---</h3>
            )}
          </div>
        </div>
      </div>
      <div className="slot-buttons">
        <button onClick={cancel} className="slot-cancel">
          cancel
        </button>
        <button
          onClick={bookSlot}
          disabled={isBookingSlot}
          className="slot-confirm"
        >
          {isBookingSlot ? "confirming..." : "confirm"}
        </button>
      </div>
    </div>
  );
};

Review.propTypes = {
  bookSlot: PropTypes.any,
  cancel: PropTypes.any,
  disableButton: PropTypes.any,
  isBookingSlot: PropTypes.any,
  state: PropTypes.shape({
    date: PropTypes.any,
    month: PropTypes.any,
    selectedDay: PropTypes.any,
    start_time: PropTypes.any,
    year: PropTypes.any,
  }),
  text: PropTypes.any,
  type: PropTypes.string,
};

export default Review;
